export enum OpprtunityFormTabPages {
  About = 0,
  Media = 1,
  WhenWhere = 2,
}
